const offersModal = document.getElementById('allOffers');

const initSliders = () => {
	const sliderHero = new Swiper('.js-slider-hero .slider__clip', {
		speed: 1000,
		loop: true,
    init: false,
		autoplay: {
		  delay: 2000,
		},
    zoom: true,
    watchOverflow: true,
		pagination: {
      el: '.js-slider-hero .slider__dots',
      type: 'bullets',
      clickable: true,
      bulletClass: 'slider__dot'
    },
    slidesPerView: 1,
    breakpoints: {
      320: {
      	slidesPerView: 1,
        spaceBetween: 2,
      },
      768: {
      	slidesPerView: 'auto',
        spaceBetween: -10,
      },
      992: {
      	slidesPerView: 'auto',
        spaceBetween: 2
      }
    }
	});

  Array.from(document.querySelectorAll('.js-slider-hero')).map((slider, index) => {
    if (slider.querySelectorAll('.slider__slide').length > 1) {
      sliderHero[index].init();
    }
  });

	const slidernews = new Swiper('.js-slider-news .slider__clip', {
		speed: 1000,
		loop: true,
    init: false,
		autoplay: {
		  delay: 2000,
		},
		pagination: {
      el: '.js-slider-news .slider__dots',
      type: 'bullets',
      clickable: true,
      bulletClass: 'slider__dot'
    },
    observer: true,
    observeParents: true,
    breakpoints: {
      320: {
      	slidesPerView: 1,
        spaceBetween: 2,
      },
      768: {
      	slidesPerView: 'auto',
        spaceBetween: 0,
      },
      992: {
      	slidesPerView: 'auto',
        spaceBetween: 2
      }
    }
	});

  Array.from(document.querySelectorAll('.js-slider-news')).map((slider, index) => {
    if (slider.querySelectorAll('.slider__slide').length > 1) {
      slidernews[index].init();
    }
  });

	if(offersModal) {
		offersModal.addEventListener('shown.bs.modal', function (event) {
		  const sliderSimple = new Swiper('.js-slider-simple .slider__clip', {
				slidesPerView: 1,
		    spaceBetween: 0,
				speed: 1000,
				loop: false,
				autoplay: {
				  delay: 2000,
				},
				pagination: {
		      el: '.js-slider-simple .slider__dots',
		      type: 'bullets',
		      clickable: true,
		      bulletClass: 'slider__dot'
		    }
			});
		});
	}
};

initSliders();
